module.exports = __webpack_public_path__ + "img/MG.6ab4fb25.png";